<script>

export default {

    components: {

    },

    props: {

    },

    data: function(){
        return {
            displayed: false,
        };
    },

    computed: {

    },

    mounted: function(){

    },

    methods: {
        openDialog() {
            this.displayed = true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/page/Application/open-dialog-mixin.vue